/* 🤖 this file was generated by svg-to-ts */
export const iconChevronLeft: {
    name: 'chevron_left';
    data: string;
} = {
    name: 'chevron_left',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14"><path fill="#000" fill-rule="evenodd" d="m.308 7 .008-.1.023-.097a.7.7 0 0 1 .091-.182l.069-.08L6.582.457a.65.65 0 0 1 .988.838l-.069.081-5.624 5.625 5.624 5.623a.65.65 0 0 1-.838.988l-.08-.069L.504 7.466.5 7.46A.65.65 0 0 1 .309 7"/></svg>`
};
